import { VoiceCallModel } from "../schema";

export class VoiceCallContainer {
    voice_call: VoiceCallModel
}